// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import medicosReducer from './medicosSlice';

export const store = configureStore({
  reducer: {
    medicos: medicosReducer,
  },
});

export default store;
